import { useUpdateProductAdjustment } from 'api-hooks/product/adjustment/mutation';
import { useGetProductAdjustment } from 'api-hooks/product/adjustment/query';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useDismiss from 'hooks/use-dismiss';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import ProductAdjustmentForm from './components/form';

export type ProductAdjustmentViewParams = {
  id: string;
};

export default function ProductAdjustmentView(
  props: NavigationProps<NavigationRoutes.ProductAdjustmentView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } =
    useGetProductAdjustment({
      id,
    });
  const { mutateAsync, error: errorMutate } = useUpdateProductAdjustment();

  const productAdjustment = data?.data;

  const onDismiss = useDismiss('product-adjustments', productAdjustment?.id);

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <ProductAdjustmentForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            productAdjustment={productAdjustment}
            onSubmit={async (input, form) => {
              const result = await mutateAsync({
                id: productAdjustment!.id!,
                body: input,
              });

              onDismiss(result.data.id);

              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
